import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const RACallResponseDropdownClickEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.RESO_ASSIST_CALL_RESPONSE_DROPDOWN_CLICK_EVENT,
    properties,
  );

export const RAProceedBtnClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.RESO_ASSIST_PROCEED_BTN_CLICK_EVENT, properties);
